import { useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";
import { Select } from "@/components/shared/forms";

import type { GalleryProps } from "./gallery-component";

export default function GallerySettings() {
  const { props, actions } = useNode((node) => ({
    props: node.data.props as GalleryProps,
  }));
  const { t } = useTranslation();

  const options = React.useMemo(() => {
    return [2, 3, 4].map((item) => ({
      label: String(item),
      value: String(item),
    }));
  }, []);

  return (
    <React.Fragment>
      <SettingsTitleWrapper title={t("preference-panel.gallery")}>
        <div className="grid gap-4">
          <div className="grid gap-2">
            <Select
              name="columns"
              label={t("preference-panel.number-of-columns")}
              placeholder={t("preference-panel.select-an-option")}
              options={options}
              value={String(props.columns)}
              onChange={(value) => {
                actions.setProp(
                  (props: GalleryProps) => (props.columns = Number(value))
                );
              }}
            />
          </div>
        </div>
      </SettingsTitleWrapper>
    </React.Fragment>
  );
}
